import { combineReducers } from 'redux-immutable'

import moduleMenuReducer from './Gnosus/components/ModuleMenu/reducer'
import dropdownMenuReducer from './Gnosus/components/MainMenu/components/DropDownMenu/reducer'
import ribbonReducer from './Gnosus/components/Ribbon/reducer'
import workspaceReducer from './Gnosus/components/Workspace/reducer'
import toolbarReducer from './Gnosus/components/Toolbar/reducer'
import tabsReducer from './Gnosus/components/Tabs/reducer'
import modulesReducers from './Gnosus/scenes/reducers'
import loaderReducer from '../services/loader/reducer'
import entityStackReducer from './Gnosus/components/EntityStack/reducer'
import groupStackReducer from './Gnosus/components/GroupStack/reducer'
import blockTableReducer from './Gnosus/components/Workspace/components/BlockTable/reducer'
import userProfileReducer from '../components/Dialog/components/UserProfile/reducer'
import groupMonitoringReducer from '../components/Dialog/components/GroupMonitoring/reducer'
import manageGroupsReducer from '../components/Dialog/components/ManageGroups/reducer'
import minireportReducer from '../components/Minireport/reducer'
import googleMapReducer from '../components/GoogleMap/reducer'

const rootReducer = combineReducers({
    moduleMenu: moduleMenuReducer,
    dropdown: dropdownMenuReducer,
    entityStack: entityStackReducer,
    groupStack: groupStackReducer,
    ribbon: ribbonReducer,
    workspace: workspaceReducer,
    tabs: tabsReducer,
    modules: modulesReducers,
    loader: loaderReducer,
    blockTable: blockTableReducer,
    toolbar: toolbarReducer,
    userProfile: userProfileReducer,
    groupMonitoring: groupMonitoringReducer,
    manageGroups: manageGroupsReducer,
    minireport: minireportReducer,
    googleMap: googleMapReducer,
})

export default rootReducer
